module.exports = __webpack_public_path__ + "static/media/0327_IMG_LES_STRUCTURES_GONDOLES.d340d3e5.png";